export const ON_MOUNT_EDITOR = 'ON_MOUNT_EDITOR';
export const GET_NEWSLETTER = 'GET_NEWSLETTER';
export const GET_NEWSLETTER_PUBLIC = 'GET_NEWSLETTER_PUBLIC';
export const PUBLISH = 'PUBLISH';
export const ON_MOUNT_PUBLIC = 'ON_MOUNT_PUBLIC';

export const EMAIL_FIELDS_ID = 'EMAIL_FIELDS_ID';
